import {
    Drawer,
    DrawerProps,
    ScrollArea
} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {moduleConfig} from "../config";
import {ApplicationProductRecordFormProps} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<ApplicationProductRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${moduleConfig.titles.singular}`
        : `New ${moduleConfig.titles.singular}`

    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={(values) => {
                    handleSubmit(values)
                    onClose();
                }}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
